import React from 'react';
import SelectInput from '@sabre/spark-react-core/select-input';
import { OPERATOR_OPTIONS } from './search-criteria-modal-util.js';

const SearchCriteriaModalCriteriaOperator = ({
   key,
   completeSearchSet,
   criteriaOperator,
   criteriaOperatorOnChangeHandler,
   rowIndex,
}) => {
   return (
      <SelectInput
         key={key}
         name={`Operator${rowIndex}`}
         options={OPERATOR_OPTIONS}
         value={criteriaOperator}
         label='Operator'
         onChange={(selectedValue) =>
            criteriaOperatorOnChangeHandler(
               selectedValue,
               completeSearchSet,
               rowIndex
            )
         }
      />
   );
};

SearchCriteriaModalCriteriaOperator.propTypes = {};

export default SearchCriteriaModalCriteriaOperator;
